import React from 'react';
import { Button } from './ui/Button';
interface HookSectionProps {
  onStart: () => void;
}
export function HookSection({
  onStart
}: HookSectionProps) {
  return <div style={{
    display: 'flex',
    flexDirection: 'column',
    gap: '4rem'
  }} data-id="element-43">
      <header style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '2rem'
    }} data-id="element-44">
        <h1 style={{
        fontSize: 'clamp(1.875rem, 4vw, 2.25rem)',
        lineHeight: '1.2'
      }} data-id="element-45">
          UX Guide for Brand and Marketing Meetings
        </h1>

        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        fontSize: '1.125rem',
        lineHeight: '1.7'
      }} data-id="element-46">
          <p data-id="element-47">
            You're here because I mentioned a small book I wrote after sitting
            in too many confusing meetings.
          </p>
          <p data-id="element-48">
            It's called <em data-id="element-49">No Theory. Just the Words That Matter.</em>
          </p>
          <p data-id="element-50">
            It's a straight talking A to Z of the terms people use in brand,
            website and marketing conversations. 85+ terms defined. A bit of
            humour. The occasional bad word.
          </p>
          <p data-id="element-51">Before you download it, one quick check.</p>
        </div>

        <p style={{
        fontSize: '0.875rem',
        color: '#8A8A85',
        lineHeight: '1.6'
      }} data-id="element-52">
          Trusted by teams, manufacturing, product-led businesses and
          professional services.
        </p>
      </header>

      <section style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem'
    }} data-id="element-53">
        <h2 style={{
        fontSize: 'clamp(1.5rem, 3.5vw, 1.875rem)',
        lineHeight: '1.2'
      }} data-id="element-54">
          Ever left a meeting thinking… what just happened?
        </h2>
        <p style={{
        fontSize: '1.125rem',
        color: '#8A8A85',
        lineHeight: '1.6'
      }} data-id="element-55">
          Take two minutes before you download the guide.
        </p>
        <div style={{
        paddingTop: '0.5rem'
      }} data-id="element-56">
          <Button onClick={onStart} fullWidth aria-label="Start the quick check" data-id="element-57">
            Start the quick check
          </Button>
        </div>
      </section>
    </div>;
}